import { SingleResponse } from "@/src/core/response"
import { sendRequest } from "@/src/core/http-client"
import MerchantPolling from "@/src/interfaces/polling/merchant"

export class MerchantPollingService {
    static async getById(merchantId: string, appAccessToken?: string): Promise<SingleResponse<MerchantPolling.ByIdResponse>> {
        return sendRequest<MerchantPolling.ByIdResponse>(
            appAccessToken,
            `${process.env.NEXT_PUBLIC_POLLING_URL}/merchants/${merchantId}`,
            'GET'
        )
    }

    static async getStatus(merchantId: string, appAccessToken?: string): Promise<SingleResponse<MerchantPolling.StatusResponse>> {
        return sendRequest<MerchantPolling.StatusResponse>(
            appAccessToken,
            `${process.env.NEXT_PUBLIC_POLLING_URL}/merchants/${merchantId}/status`,
            'GET'
        )
    }
}